import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Layout } from 'antd'
import { HeaderSection } from 'app/components/Layouts'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import ModernTabNavigation from '../../components/ModernTabNavigation'
import DepositManagement from './DepositManagement'
import WithdrawalManagement from './WithdrawalManagement'
import Other from './other'
import { APPNAME } from 'app/constants/APIKEYS'
import PGDepositPage from './PGDepositPage'
import PGWithdrawPage from './PGWithdrawPage'

const StyledLayout = styled(Layout)`
  background: #f8f9fa;
  min-height: 100vh;
`

const StyledContent = styled(Layout.Content)`
  padding: 0 50px 20px;

  @media (max-width: 768px) {
    padding: 0 5px 20px;
  }
`
export const AdminCashPage = () => {
	const location = useLocation()
	const url = location.pathname

	const items = [
		{
			title: '입금관리',
			link: '/cash/deposit',
		},
		{
			title: '출금관리',
			link: '/cash/withdrawal',
		},
		{
			title: '별도입출금',
			link: '/cash/other',
		},
		{
			title: 'PG입출금',
			link: '/cash/pg/deposit',
		},
	]

	const renderContent = () => {
		switch (true) {
			case url.startsWith('/cash/pg/deposit'):
				return <PGDepositPage />
			case url.startsWith('/cash/pg/withdraw'):
				return <PGWithdrawPage />
			case url === '/cash/deposit':
				return <DepositManagement title={'입금관리'} />
			case url === '/cash/withdrawal':
				return <WithdrawalManagement title={'출금관리'} />
			case url === '/cash/other':
				return <Other />
			default:
				return <DepositManagement title={'입금관리'} />
		}
	}

	return (
		<StyledLayout>
			<Helmet>
				<title>{APPNAME + " ADMIN - 현금입출금"}</title>
			</Helmet>
			<HeaderSection />
			<ModernTabNavigation items={items} />
			<StyledContent>
				{renderContent()}
			</StyledContent>
		</StyledLayout>
	)
}
